import type { TableData } from './types'

import { getTableBottomOffset, getTableTopOffset } from './utils'

let tables: TableData[] = []

export const measureTables = (): void => {
  tables = []
  const headerElements: NodeListOf<HTMLElement> = document.querySelectorAll(
    '.usr-repeated-header'
  )

  Array.from(headerElements).forEach((header, index) => {
    const table = header.closest('table')
    if (!table) {
      return
    }

    const headerPristineTop =
      header.getBoundingClientRect().top + window.scrollY

    tables.push({
      index,
      table,
      header,
      headerTopOriginal: headerPristineTop,
    })
  })
}

export const clearTables = (): void => {
  tables = []
}

export const getCorrectTable = (
  distance: number,
  hideSamepageHeader: boolean
): TableData | null => {
  const table = tables.find(
    (obj) =>
      distance >= getTableTopOffset(obj.table) &&
      distance <= getTableBottomOffset(obj.table)
  )

  //If we find a table, but none of the other tables should show headers, we return the first table
  if (table && hideSamepageHeader) return tables[0]
  return table || null
}
